import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

export const getActs = createAsyncThunk(
  'accountingKitchensPayments/getActs',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/payment/getActs?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.payments || [];
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const createPayment = createAsyncThunk(
  'accountingKitchensPayments/createPayment',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/payment/createPayment?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updatePaymentStatus = createAsyncThunk(
  'accountingKitchensPayments/updatePaymentStatus',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/payment/createTbankDraft?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const checkPayment = createAsyncThunk(
  'accountingKitchensPayments/checkPayment',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/payment/getTbankPaymentStatus?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          documentUuid: data.documentId,
          isExecuted: response.data.data.documents.some(doc => doc.documentUuid === data.documentUuid && doc.status === 'EXECUTED'),
        };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const deletePayment = createAsyncThunk(
  'accountingKitchensPayments/deletePayment',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/payment/deletePayment?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getPaymentsLists = createAsyncThunk(
  'accountingKitchensPayments/getPaymentsLists',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/payment/getPaymentsList?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          paymentsList: response.data.data.paymentsList,
          pagination: response.data.data.pagination,
        };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const kitchensPaymentsActsGenerate = createAsyncThunk(
  'accountingKitchensPayments/kitchensPaymentsActsGenerate',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/payments/acts/generate?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

const initialState = {
  getActsStatus: null,
  createPaymentStatus: null,
  updatePaymentStatusStatus: null,
  checkPaymentStatus: null,
  deletePaymentStatus: null,
  getPaymentsListsStatus: null,
  kitchensPaymentsActsGenerateStatus: null,

  filters: {
    kitchenIds: null,
    from: null,
    to: null,
  },

  acts: [],
  paymentsLists: [],
  currentPage: 1,
  totalPages: 1,
  total: 0,
  selectedCells: [],
  modalCellData: null,
};

const accountingKitchensPaymentsReducerSlice = createSlice({
  name: 'accountingKitchensPaymentsReducer',
  initialState,
  extraReducers: (builder) => {
    builder
      //getActs
      .addCase(getActs.pending, (state) => { state.getActsStatus = 'pending'; })
      .addCase(getActs.fulfilled, (state, action) => {
        state.getActsStatus = 'fulfilled';
        state.acts = action.payload;
      })
      .addCase(getActs.rejected, (state) => { state.getActsStatus = 'rejected'; })

      //createPayment
      .addCase(createPayment.pending, (state) => { state.createPaymentStatus = 'pending'; })
      .addCase(createPayment.fulfilled, (state) => { 
        state.createPaymentStatus = 'fulfilled'; 
        state.selectedCells = [];
      })
      .addCase(createPayment.rejected, (state) => { state.createPaymentStatus = 'rejected'; })

      //updatePaymentStatus
      .addCase(updatePaymentStatus.pending, (state) => { state.updatePaymentStatusStatus = 'pending'; })
      .addCase(updatePaymentStatus.fulfilled, (state) => { state.updatePaymentStatusStatus = 'fulfilled'; })
      .addCase(updatePaymentStatus.rejected, (state) => { state.updatePaymentStatusStatus = 'rejected'; })

      //checkPayment
      .addCase(checkPayment.pending, (state) => { state.checkPaymentStatus = 'pending'; })
      .addCase(checkPayment.fulfilled, (state, action) => {
        const { documentUuid, isExecuted } = action.payload;
        console.log(documentUuid, isExecuted);

        state.checkPaymentStatus = 'fulfilled';

        if (!isExecuted) return;

        const paymentIndex = state.paymentsLists.findIndex(payment => payment.documentUuid === documentUuid);
        if (paymentIndex !== -1) {
          state.paymentsLists[paymentIndex] = {
            ...state.paymentsLists[paymentIndex],
            documentStatus: "EXECUTED",
            status: 3,
          };
        }
      })
      .addCase(checkPayment.rejected, (state) => { state.checkPaymentStatus = 'rejected'; })
      
      //deletePayment
      .addCase(deletePayment.pending, (state) => { state.deletePaymentStatus = 'pending'; })
      .addCase(deletePayment.fulfilled, (state) => { state.deletePaymentStatus = 'fulfilled'; })
      .addCase(deletePayment.rejected, (state) => { state.deletePaymentStatus = 'rejected'; })

      //getPaymentsList
      .addCase(getPaymentsLists.pending, (state) => { state.getPaymentsListsStatus = 'pending'; })
      .addCase(getPaymentsLists.fulfilled, (state, action) => {
        state.getPaymentsListsStatus = 'fulfilled';
        state.paymentsLists = action.payload.paymentsList;
        state.totalPages = action.payload.pagination.lastPage;
        state.total = action.payload.pagination.total
      })
      .addCase(getPaymentsLists.rejected, (state) => { state.getPaymentsListsStatus = 'rejected'; })

      //kitchensPaymentsActsGenerate
      .addCase(kitchensPaymentsActsGenerate.pending, (state) => { state.kitchensPaymentsActsGenerateStatus = 'pending'; })
      .addCase(kitchensPaymentsActsGenerate.fulfilled, (state) => { state.kitchensPaymentsActsGenerateStatus = 'fulfilled'; })
      .addCase(kitchensPaymentsActsGenerate.rejected, (state) => { state.kitchensPaymentsActsGenerateStatus = 'rejected'; })

      // PURGE
      .addCase(PURGE, () => initialState);
  },
  reducers: {
    clearState: (state) => {
      state.filters = {
        kitchenIds: null,
        from: null,
        to: null,
      };
      state.acts = [];
      state.paymentsLists = [];
      state.getActsStatus = null;
      state.createPaymentStatus = null;
      state.updatePaymentStatusStatus = null;
      state.deletePaymentStatus = null;
      state.getPaymentsListsStatus = null;
      state.currentPage = 1;
      state.totalPages = 1;
      state.total = 0;
      state.selectedCells = [];
      state.modalCellData = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setSelectedCells: (state, action) => {
      state.selectedCells = action.payload;
    },
    setModalCellData: (state, action) => {
      state.modalCellData = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    resetCreatePaymentStatus: (state) => {
      state.createPaymentStatus = null;
    },
    resetUpdatePaymentStatusStatus: (state) => {
      state.updatePaymentStatusStatus = null;
    },
    resetDeletePaymentStatus: (state) => {
      state.deletePaymentStatus = null;
    },
  },
});

export const {
  clearState,
  setFilters,
  setSelectedCells,
  setModalCellData,
  setCurrentPage,
  resetCreatePaymentStatus,
  resetUpdatePaymentStatusStatus,
  resetDeletePaymentStatus,
} = accountingKitchensPaymentsReducerSlice.actions;

export default accountingKitchensPaymentsReducerSlice.reducer;
